// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"90151b24","453":"06d71193"}[chunkId] + ".chunk.js";
};